import * as R from 'Router/routes';
import { LatestLoan } from 'hooks/webapi/useLatestLoan';
import { useClient, useLatestLoan } from 'hooks/webapi';
import { useNavigate } from 'react-router-dom';
import { userIsNotIdentified } from 'utils/userIsNotIdentified';
import useSelektra from 'pages/SelektraPage/useSelektra';

const useConditionalNavigation = () => {
  const { client } = useClient();
  const { latestLoan } = useLatestLoan();
  const { isSelektraPageRequired } = useSelektra();
  const navigate = useNavigate();

  const navigateToDashboard = (
    fetchedLatestLoan?: LatestLoan | null | undefined | void,
  ) => {
    const loanToCheck = fetchedLatestLoan || latestLoan;
    let dashboard = R.ACTIVE_LOAN;
    if (!loanToCheck) dashboard = R.REPEATED_LOAN;
    if (isSelektraPageRequired(loanToCheck)) dashboard = R.SELEKTRA_ROUTE;

    navigate(dashboard);
  };

  const pendingRoute = client?.hasAttachments
    ? R.DOCUMENTS_PENDING
    : R.DOCUMENTS_PENDING_UPLOAD;

  const userNotIdentified = userIsNotIdentified(client);
  const backUrl =
    (userNotIdentified && pendingRoute) ||
    (latestLoan ? R.ACTIVE_LOAN : R.REPEATED_LOAN);

  const navigatePendingScreen = () => navigate(pendingRoute);

  return { navigateToDashboard, navigatePendingScreen, pendingRoute, backUrl };
};

export default useConditionalNavigation;
